export const POPOVER_PROPS = {
  style: {
    zIndex: 1500
  }
};

export const RESCHEDULE_MODES = {
  Tomorrow: 'tomorrow',
  Custom: 'custom'
};

export const FIELD_KEYS = {
  Date: 'date',
  Time: 'time'
};
